import moment from 'moment';

export const PERIODOS_RELATORIO = [
  { value: '30', label: '30 dias' },
  { value: '90', label: '90 dias' },
  { value: '180', label: '6 meses' },
  { value: 'all', label: 'Tudo' },
];

export function agruparPor(colecao, chave, labelPadrao = 'Não informado') {
  return colecao.reduce((acc, item) => {
    const key = item[chave] || labelPadrao;
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});
}

export function labelCruzamento(os) {
  if (os.cruzamento) return os.cruzamento;
  if (os.controlador_numero) return `Ctrl ${os.controlador_numero}`;
  return 'Sem local';
}

export function osEstaAberta(os) {
  return !['FINALIZADA', 'CANCELADA'].includes(os.status);
}

export function osSlaVencida(os) {
  if (!os.data_prazo || os.status === 'FINALIZADA' || os.status === 'CANCELADA') return false;
  return new Date(os.data_prazo) < new Date();
}

export function filtrarOrdensRelatorio(ordens, { periodo = 'all', equipeId = '' } = {}) {
  let resultado = ordens || [];

  if (periodo && periodo !== 'all') {
    const dias = parseInt(periodo, 10);
    const limite = moment().subtract(dias, 'days').startOf('day');
    resultado = resultado.filter(o => o.data_abertura && moment(o.data_abertura).isSameOrAfter(limite));
  }

  if (equipeId) {
    resultado = resultado.filter(o => String(o.equipe_id) === String(equipeId));
  }

  return resultado;
}

export function resumoPorEquipe(ordens) {
  const mapa = {};

  (ordens || []).forEach(os => {
    const nome = os.equipe_nome || 'Sem equipe';
    if (!mapa[nome]) {
      mapa[nome] = { equipe: nome, total: 0, abertas: 0, finalizadas: 0, slaVencido: 0 };
    }
    mapa[nome].total += 1;
    if (osEstaAberta(os)) mapa[nome].abertas += 1;
    if (os.status === 'FINALIZADA') mapa[nome].finalizadas += 1;
    if (osSlaVencida(os)) mapa[nome].slaVencido += 1;
  });

  return Object.values(mapa).sort((a, b) => b.total - a.total);
}

export function resumoPorCruzamento(ordens) {
  const mapa = {};

  (ordens || []).forEach(os => {
    const nome = labelCruzamento(os);
    if (!mapa[nome]) {
      mapa[nome] = { cruzamento: nome, total: 0, abertas: 0, finalizadas: 0, slaVencido: 0 };
    }
    mapa[nome].total += 1;
    if (osEstaAberta(os)) mapa[nome].abertas += 1;
    if (os.status === 'FINALIZADA') mapa[nome].finalizadas += 1;
    if (osSlaVencida(os)) mapa[nome].slaVencido += 1;
  });

  return Object.values(mapa).sort((a, b) => b.total - a.total);
}

export function dadosGraficoCruzamento(ordens, limite = 8) {
  const contagem = {};

  (ordens || []).forEach(os => {
    const nome = labelCruzamento(os);
    contagem[nome] = (contagem[nome] || 0) + 1;
  });

  const entradas = Object.entries(contagem)
    .sort((a, b) => b[1] - a[1])
    .slice(0, limite);

  return {
    labels: entradas.map(([nome]) => nome),
    datasets: [
      {
        label: 'OS',
        data: entradas.map(([, qtd]) => qtd),
        backgroundColor: 'rgba(22, 160, 133, 0.75)',
        borderColor: '#16a085',
        borderWidth: 1,
      },
    ],
  };
}
